import { DateFormatType, formatDate } from "~/common/utils/DateFormatter";
import { type NotificationContext, type NotificationData, Notifications } from "~/features/notifications/Messages";
import { ListItem, IconButton, styled, Typography } from "~/common/mui";
import DraftsIcon from "@mui/icons-material/Drafts";
import MailIcon from "@mui/icons-material/Mail";
import { listItemClasses } from "~/common/mui";
import { MENU_ITEM_PADDING } from "~/app/themeConstants";

interface NotificationItemProps {
  notification: NotificationData;
  readMessage: (item: NotificationData) => Promise<unknown>;
}

export const NotificationsItem = ({ notification, readMessage }: NotificationItemProps) => {
  const context: NotificationContext = {
    markAsRead: async (data) => {
      if (!data.read) {
        // TODO FIXME
        await readMessage(data);
      }
    },
  };

  const action = (
    <IconButton
      color="primary"
      size="large"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        readMessage(notification);
      }}
    >
      {notification.read ? <MailIcon fontSize="small" /> : <DraftsIcon fontSize="small" />}
    </IconButton>
  );

  return (
    <NotificationItemRoot
      // sx={{
      //   backgroundColor: notification.read ? "white" : undefined,
      // }}
      data-ta-title={Notifications.renderTitleGA(notification, context)}
      data-ta-spec={"notification-block"}
      secondaryAction={action}
    >
      <Typography component={"p"} variant="labelLarge" fontWeight="bold" sx={{ mb: 0.5 }}>
        {Notifications.renderTitle(notification, context)}
      </Typography>
      <Typography sx={{ maxWidth: "90%", mb: 1 }}>{Notifications.renderDescription(notification, context)}</Typography>
      <Typography sx={{ textAlign: "right" }}>
        {formatDate(new Date(notification.notificationDate), DateFormatType.DATE)}
      </Typography>
    </NotificationItemRoot>
  );
};

const NotificationItemRoot = styled(ListItem)({
  padding: MENU_ITEM_PADDING,
  paddingRight: "48px",
  wordBreak: "break-word",
  display: "block",

  [`& .${listItemClasses.secondaryAction}`]: {
    right: 0,
  },
});
